export default {
    COUNTRY_CODE: 'Country code',
    PHONE_NUMBER: 'Phone number',
    MOBILE_NUMBER: 'Mobile number',
    ON: 'On',
    OFF: 'Off',
};
